<template>
  <div class="max-w-[90vw] mx-auto">
    <div class="w-full flex justify-end align-center">
      <v-container class="onest-font">
        <a
          @click.prevent="goBack"
          style="color: inherit; cursor: pointer; text-decoration: none"
          class="d-flex align-center d-inline-flex"
        >
          <v-icon size="20" class="mr-1">mdi-arrow-u-left-bottom</v-icon>
          <span style="text-decoration: underline">voltar</span>
        </a>
        <h1 class="font-bold mt-2 text-5xl">Convites de Usuários</h1>
        <div class="text-lg mt-2 flex flex-col">
          <span v-if="projeto" class="font-bold">
            Projeto: <span class="font-medium">{{ projeto.nome }}</span>
          </span>
          <span v-if="projeto" class="font-bold">
            Validação:
            <span class="font-medium">{{ projeto.validacao }}</span>
          </span>
        </div>
      </v-container>
      <v-container class="onest-font d-flex justify-end gap-2">
        <v-btn
          variant="flat"
          prepend-icon="mdi-email-arrow-right"
          color="primary"
          @click="openModalSendInvite"
        >
          Enviar Convite
        </v-btn>
      </v-container>
    </div>
    <v-container>
      <div class="search-bar w-full pb-4">
        <v-text-field
          v-model="searchQuery"
          variant="solo"
          flat
          hide-details
          class="search-input"
          placeholder="Buscar usuário por nome ou email"
          aria-label="Buscar usuário por nome ou email"
          append-inner-icon="mdi-magnify"
        ></v-text-field>
      </div>

      <!-- Menu de Filtros por Ator -->
      <div class="status-filters w-full pb-4 onest-font">
        <v-chip-group
          v-model="selectedAtor"
          column
          mandatory
          selected-class="bg-primary text-white"
        >
          <v-chip value="TODOS" variant="outlined" class="font-medium">
            Todos os papéis
          </v-chip>
          <v-chip
            v-for="ator in atores"
            :key="ator.id_ator"
            :value="ator.nome_ator"
            variant="outlined"
            class="font-medium"
          >
            {{ ator.nome_ator }}
          </v-chip>
        </v-chip-group>
      </div>

      <div v-if="loading" class="py-12 text-center text-gray-500 font-medium">
        <v-progress-circular
          indeterminate
          color="primary"
          class="mb-4"
        ></v-progress-circular>
        <p>Carregando convites...</p>
      </div>

      <v-row v-else>
        <v-col>
          <div class="my-4">
            <table class="w-full border-separate border-spacing-y-2">
              <thead class="p-2">
                <tr class="">
                  <th class="p-4 font-medium text-left">Nome do usuário</th>
                  <th class="p-4 font-medium text-left">Email</th>
                  <th class="p-4 font-medium text-left">Papéis</th>
                  <th class="p-4 font-medium text-left">Data do Convite</th>
                  <th class="p-4 font-medium text-left">Status</th>
                  <th class="p-4 font-medium text-left">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="user in filteredTestUsers"
                  :key="user.id"
                  class="hover:bg-blue-50/50 transition-colors bg-white shadow-sm"
                >
                  <td class="py-4 px-6 font-medium text-gray-600 rounded-l-xl">
                    {{ user.nome }}
                  </td>
                  <td class="py-4 px-6 text-gray-600">{{ user.email }}</td>
                  <!-- COLUNA DE PAPÉIS -->
                  <td class="py-4 px-6 text-gray-600">
                    <div class="flex items-center gap-1">
                      <template v-if="user.papeis && user.papeis.length > 0">
                        <!-- Chip do primeiro papel -->
                        <v-chip
                          size="x-small"
                          :color="
                            user.papeis[0].flagAceito
                              ? 'success'
                              : user.papeis[0].justificativa
                              ? 'error'
                              : 'warning'
                          "
                          variant="tonal"
                          class="font-medium"
                        >
                          {{ user.papeis[0].nomeAtor }}
                          <span
                            v-if="user.papeis[0].flagAceito"
                            class="ml-1 text-[9px]"
                            >(Aceito)</span
                          >
                          <span
                            v-else-if="user.papeis[0].justificativa"
                            class="ml-1 text-[9px]"
                            >(Recusado)</span
                          >
                          <span v-else class="ml-1 text-[9px]">(Pendente)</span>
                        </v-chip>

                        <!-- Quantidade de papéis restantes (ex: +1) -->
                        <span
                          v-if="user.papeis.length > 1"
                          class="text-xs font-semibold text-gray-500 ml-1"
                        >
                          +{{ user.papeis.length - 1 }}
                        </span>
                      </template>
                    </div>
                  </td>
                  <td class="py-4 px-6 text-gray-600">
                    {{ formatarData(user.dataConvite) }}
                  </td>
                  <td class="py-4 px-6 text-left">
                    <v-chip
                      :color="getStatusColor(user.flagAceito)"
                      class="font-medium"
                      size="small"
                      variant="tonal"
                    >
                      {{ formatarStatus(user.flagAceito) }}
                    </v-chip>
                  </td>
                  <td class="py-4 px-6 text-left rounded-r-xl">
                    <div class="d-flex align-center gap-2">
                      <!-- Visualizar Papéis (se tiver mais de 1) -->
                      <v-tooltip
                        v-if="user.papeis && user.papeis.length > 1"
                        location="bottom"
                        text="Visualizar Papéis"
                      >
                        <template #activator="{ props: tooltipProps }">
                          <ModalVisualizarPapeis
                            :papeis="user.papeis"
                            :usuario-nome="user.nome"
                          >
                            <template #activator="{ props: modalProps }">
                              <v-btn
                                v-bind="{ ...tooltipProps, ...modalProps }"
                                color="primary"
                                variant="text"
                                size="small"
                                class="text-center font-normal rounded-full"
                              >
                                <v-icon>mdi-format-list-bulleted</v-icon>
                              </v-btn>
                            </template>
                          </ModalVisualizarPapeis>
                        </template>
                      </v-tooltip>

                      <!-- Associar Conta Teste -->
                      <v-tooltip
                        v-if="user.flagAceito === 'aceito'"
                        location="bottom"
                        text="Associar Conta Teste"
                      >
                        <template #activator="{ props: tooltipProps }">
                          <ModalAssociarContaTeste
                            :user="user"
                            :id-validacao="idValidacao"
                            @associacao-alterada="fetchTestUsers"
                          >
                            <template #activator="{ props: modalProps }">
                              <v-btn
                                v-bind="{ ...tooltipProps, ...modalProps }"
                                color="grey-darken-1"
                                variant="text"
                                size="small"
                                class="text-center font-normal rounded-full"
                              >
                                <v-icon>mdi-account-hard-hat</v-icon>
                              </v-btn>
                            </template>
                          </ModalAssociarContaTeste>
                        </template>
                      </v-tooltip>

                      <!-- Ver Justificativa -->
                      <v-tooltip
                        v-else-if="user.flagAceito === 'recusado'"
                        location="bottom"
                        text="Ver Justificativa"
                      >
                        <template #activator="{ props }">
                          <v-btn
                            v-bind="props"
                            color="grey-darken-1"
                            variant="text"
                            size="small"
                            @click="verJustificativa(user)"
                            class="text-center font-normal rounded-full"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>

                      <!-- Reenviar / Deletar Convite -->
                      <template v-else-if="user.flagAceito === 'pendente'">
                        <v-tooltip location="bottom" text="Reenviar Convite">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              color="grey-darken-1"
                              variant="text"
                              size="small"
                              class="text-center font-normal rounded-full"
                            >
                              <v-icon>mdi-email-sync</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>

                        <v-tooltip location="bottom" text="Deletar Convite">
                          <template #activator="{ props }">
                            <v-btn
                              v-bind="props"
                              color="error"
                              variant="text"
                              size="small"
                              @click="confirmarDeletarConvite(user)"
                              class="text-center font-normal rounded-full"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </template>
                    </div>
                  </td>
                </tr>
                <tr v-if="filteredTestUsers.length === 0">
                  <td colspan="6" class="py-8 text-center text-gray-500">
                    Nenhum usuário encontrado na busca.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <ModalSendInvite
      v-model:ativo="showModalSendInvite"
      :id-projeto="idProjeto"
      @enviar-convite="handleEnviarConvite"
    />

    <!-- Dialog para ver justificativa -->
    <v-dialog v-model="justificationDialog" max-width="500px">
      <v-card class="rounded-2xl p-4">
        <v-card-title class="font-bold text-xl text-gray-800">
          Justificativas de Recusa
        </v-card-title>
        <v-card-text>
          <div
            v-for="papel in selectedUserPapeisRecusados"
            :key="papel.nomeAtor"
            class="mb-4"
          >
            <p class="font-semibold text-gray-700">{{ papel.nomeAtor }}:</p>
            <p
              class="text-gray-600 bg-gray-50 p-3 rounded-xl border border-gray-100 italic mt-1"
            >
              "{{ papel.justificativa || 'Sem justificativa informada' }}"
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            variant="flat"
            class="rounded-xl"
            @click="justificationDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para deletar convite -->
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card class="rounded-2xl p-4">
        <v-card-title class="font-bold text-xl text-gray-800">
          Confirmar Exclusão
        </v-card-title>
        <v-card-text>
          Tem certeza de que deseja deletar o convite enviado para
          <strong>{{ inviteToDelete?.nome }}</strong> ({{
            inviteToDelete?.email
          }})?
          <p class="mt-2 text-sm text-red-600 font-semibold">
            Esta ação tornará o link de acesso enviado por e-mail inválido.
          </p>
        </v-card-text>
        <v-card-actions class="justify-end gap-2">
          <v-btn
            color="grey-darken-1"
            variant="outlined"
            class="rounded-xl px-4"
            @click="deleteDialog = false"
            :disabled="deleting"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            variant="flat"
            class="rounded-xl px-4"
            @click="deletarConviteConfirmado"
            :loading="deleting"
          >
            Deletar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';

import ModalAssociarContaTeste from '@/components/dialogs/ModalAssociarContaTeste.vue';
import ModalSendInvite from '@/components/dialogs/ModalSendInvite.vue';
import ModalVisualizarPapeis from '@/components/dialogs/ModalVisualizarPapeis.vue';
import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    ModalSendInvite,
    ModalVisualizarPapeis,
    ModalAssociarContaTeste,
  },
  data() {
    return {
      searchQuery: '',
      showModalSendInvite: false,
      projeto: { nome: 'Carregando...', validacao: 'Carregando...' },
      idProjeto: '',
      idValidacao: '',
      testUsers: [],
      justificationDialog: false,
      selectedUserPapeisRecusados: [],
      atores: [],
      selectedAtor: 'TODOS',
      deleteDialog: false,
      inviteToDelete: null,
      deleting: false,
      loading: true,
    };
  },
  computed: {
    /**
     * @computed
     * @description Filtra os usuários de teste baseado na query de busca e no ator selecionado.
     * @returns {Array} Array de usuários filtrados.
     */
    filteredTestUsers() {
      let result = this.testUsers;

      // Filtro por Ator/Papel selecionado
      if (this.selectedAtor !== 'TODOS') {
        result = result.filter(
          (user) =>
            user.papeis &&
            user.papeis.some((p) => p.nomeAtor === this.selectedAtor),
        );
      }

      if (!this.searchQuery) {
        return result;
      }
      const query = this.searchQuery.toLowerCase();

      return result.filter(
        (user) =>
          user.nome.toLowerCase().includes(query) ||
          user.email.toLowerCase().includes(query) ||
          this.formatarStatus(user.flagAceito).toLowerCase().includes(query) ||
          user.flagAceito.toLowerCase().includes(query) ||
          (user.papeis &&
            user.papeis.some((p) => p.nomeAtor.toLowerCase().includes(query))),
      );
    },
  },
  mounted() {
    this.idProjeto = this.$route.params.idProjeto;
    this.fetchProjetoInfo();
    this.fetchAtores();
  },
  methods: {
    /**
     * @method
     * @description Busca as informações do projeto no backend.
     */
    fetchProjetoInfo() {
      axios
        .get(`${apiUrl}/projetos/listaprojeto/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.projeto.nome = res.data.nome || 'Projeto Desconhecido';
            const associacao = res.data.tb_projetos_envolvidos?.[0];
            const validacao = associacao?.tb_validacao;

            this.projeto.validacao =
              validacao?.nome_validacao || 'Não foi possível carregar';

            // CAPTURA E GUARDA O ID DA VALIDAÇÃO
            this.idValidacao = validacao?.id_validacao || '';

            // BUSCA OS CONVIDADOS DESTA VALIDAÇÃO ESPECÍFICA
            this.fetchTestUsers();
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar dados do projeto:', error);
          this.$toast.error('Erro ao buscar informações do projeto.');
          this.loading = false;
        });
    },
    /**
     * @method
     * @description Busca os convidados e seus papéis no backend para a validação atual.
     */
    fetchTestUsers() {
      if (!this.idValidacao) {
        this.loading = false;

        return;
      }
      this.loading = true;
      axios
        .get(`${apiUrl}/api/v1/usuario-externo/convidados`, {
          params: {
            idValidacao: this.idValidacao,
            idProjeto: this.idProjeto,
          },
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.testUsers = res.data.map((u) => ({
              id: u.id,
              idConvite: u.idConvite,
              nome: u.nome,
              email: u.email,
              dataConvite: u.dataConvite,
              flagAceito: u.status_convite, // MAPEIA status_convite DO BACKEND PARA flagAceito DO FRONTEND
              papeis: u.papeis || [],
              isExterno: u.isExterno,
            }));
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar usuários de teste:', error);
          this.$toast.error('Erro ao buscar lista de testadores.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @method
     * @description Busca os atores/papéis do projeto.
     */
    fetchAtores() {
      axios
        .get(`${apiUrl}/api/v1/ator/projeto/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.atores = res.data.ator || [];
        })
        .catch((error) => {
          console.error('Erro ao buscar atores:', error);
        });
    },
    /**
     * @method
     * @description Abre a modal para ver a justificativa.
     */
    verJustificativa(user) {
      this.selectedUserPapeisRecusados = user.papeis.filter(
        (p) => !p.flagAceito && p.justificativa,
      );
      if (this.selectedUserPapeisRecusados.length === 0) {
        this.selectedUserPapeisRecusados = [
          {
            nomeAtor: 'Geral',
            justificativa:
              'O convite foi recusado ou a fase de execução da validação passou.',
          },
        ];
      }
      this.justificationDialog = true;
    },
    /**
     * @method
     * @description Formata a data ISO para o formato DD/MM/AAAA.
     * @param {string} dataIso - Data em formato ISO.
     * @returns {string} Data formatada.
     */
    formatarData(dataIso) {
      if (!dataIso) {
        return '-';
      }
      const data = new Date(dataIso);

      return data.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },
    /**
     * @method
     * @description Retorna a cor correspondente ao status do usuário.
     * @param {string} status - Status do usuário.
     * @returns {string} Cor correspondente ao status.
     */
    getStatusColor(status) {
      if (status === 'aceito') {
        return 'success';
      }
      if (status === 'pendente') {
        return 'warning';
      }
      if (status === 'recusado') {
        return 'error';
      }

      return 'grey';
    },
    /**
     * @method
     * @description Formata o status do usuário.
     * @param {string} status - Status do usuário.
     * @returns {string} Status formatado.
     */
    formatarStatus(status) {
      if (status === 'aceito') {
        return 'Aceito';
      }
      if (status === 'pendente') {
        return 'Pendente';
      }
      if (status === 'recusado') {
        return 'Recusado';
      }

      return 'Desconhecido';
    },
    /**
     * @method
     * @description Abre o modal de envio de convite.
     */
    openModalSendInvite() {
      this.showModalSendInvite = true;
    },
    /**
     * @method
     * @description Envia o convite para o usuário chamando a API do backend.
     */
    handleEnviarConvite(dados) {
      const host = window.location.host;
      axios
        .post(
          `${apiUrl}/projetos/${this.idProjeto}/convites`,
          {
            nome: dados.nome,
            email: dados.email,
            idAtores: dados.idAtores,
            idValidacao: this.idValidacao,
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
              'X-Host': host,
            },
          },
        )
        .then(() => {
          this.$toast.success('Convite enviado com sucesso!');
          this.fetchTestUsers();
        })
        .catch((error) => {
          console.error('Erro ao enviar convite:', error);
          this.$toast.error(
            error.response?.data?.error || 'Erro ao enviar convite.',
          );
        });
    },
    /**
     * @method
     * @description Abre o diálogo de confirmação para deletar um convite.
     * @param {Object} user - O usuário convidado associado ao convite.
     */
    confirmarDeletarConvite(user) {
      this.inviteToDelete = user;
      this.deleteDialog = true;
    },
    /**
     * @method
     * @description Envia a requisição de exclusão do convite ao backend.
     */
    deletarConviteConfirmado() {
      if (!this.inviteToDelete || !this.inviteToDelete.idConvite) {
        return;
      }
      this.deleting = true;
      axios
        .delete(
          `${apiUrl}/projetos/convites/${this.inviteToDelete.idConvite}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        )
        .then(() => {
          this.$toast.success('Convite deletado com sucesso!');
          this.deleteDialog = false;
          this.fetchTestUsers();
        })
        .catch((error) => {
          console.error('Erro ao deletar convite:', error);
          this.$toast.error(
            error.response?.data?.error || 'Erro ao deletar convite.',
          );
        })
        .finally(() => {
          this.deleting = false;
          this.inviteToDelete = null;
        });
    },
    /**
     * @method
     * @description Retorna à página anterior.
     */
    goBack() {
      this.$router.push('/project-validation/' + this.$route.params.idProjeto);
    },
  },
};
</script>

<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}

:deep(.v-overlay__scrim) {
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.3) !important;
}
</style>
